export const MILISECONDS_24H = 1000 * 60 * 60 * 24;
